export default __webpack_public_path__ + "static/media/iconUpdateAt.f94f0b65.svg";